import getLang from 'I18n/utils/getLang';
import Raven from 'raven-js';
import { rpcClient } from '../../rpcClient';
import { findPurchaseOptionsRpc } from '../../../__generated__/chirp/com/hubspot/purchase/options/rpc/PurchaseOptionsService';
export const fetchPricesAndPurchaseProps = ({
  productApiNames,
  productSkusWithProductApiName,
  currencyCode
}) => {
  const priceByProductApiName = {};
  const buyingMotionPropsByProductApiName = {};
  let promiseError = undefined;
  const requestedProducts = [];
  const productApiNameBySkuUuid = {};
  for (const product of productSkusWithProductApiName) {
    requestedProducts.push({
      quantity: 1,
      skuUuid: product.skuUuid
    });
    productApiNameBySkuUuid[product.skuUuid] = product.productApiName;
    priceByProductApiName[product.productApiName] = {
      price: null,
      currencyCode
    };
    buyingMotionPropsByProductApiName[product.productApiName] = {
      currencyCode,
      products: [{
        productApiName: product.productApiName,
        incrementalQuantity: 1
      }],
      commitmentTerm: undefined,
      paymentTerm: undefined
    };
  }
  return rpcClient.call(findPurchaseOptionsRpc, {
    request: {
      products: requestedProducts,
      userContext: {
        __typename: 'com.hubspot.purchase.options.models.rpc.context.TouchlessUserContext',
        currencyCode,
        language: getLang()
      }
    }
  }).then(purchaseOptionsResponse => {
    const termPurchaseOption = purchaseOptionsResponse.purchaseOptions.find(
    // Try to display the price for the annual payment term which is the
    // most affordable option. If the portal is ineligible for an annual
    // payment term, fallback on the monthly payment term
    option => option.paymentTerm === 12) || purchaseOptionsResponse.purchaseOptions[0];

    // If the portal is only eligible for the monthly payment term, update the
    // buyingMotionPropsByProductApiName to reflect the monthly payment term
    if (termPurchaseOption.paymentTerm !== 12) {
      Object.keys(buyingMotionPropsByProductApiName).forEach(productApiName => {
        const purchaseRequest = buyingMotionPropsByProductApiName[productApiName];
        if (purchaseRequest) {
          purchaseRequest.paymentTerm = 'MONTHLY';
          purchaseRequest.commitmentTerm = 'MONTHLY';
        }
      });
    }
    for (const recurringPricedProduct of Object.values(termPurchaseOption.orderedTerms[0].recurringPricedProductBySkuUuid)) {
      priceByProductApiName[productApiNameBySkuUuid[recurringPricedProduct.skuUuid]] = {
        price: Number(recurringPricedProduct.discountedPrice.monthlyPrice),
        currencyCode
      };
    }
  }, error => {
    promiseError = error;
    Raven.captureException(new Error(error.message, {
      cause: error
    }), {
      extra: {
        productApiNames
      }
    });
  }).catch(purchaseOptionsError => {
    promiseError = purchaseOptionsError;
    Raven.captureException(new Error('fetchPricesAndPurchaseProps: Promise successfully resolved but the catch block was triggered', {
      cause: purchaseOptionsError
    }), {
      extra: {
        productApiNames
      }
    });
  }).then(() => {
    if (promiseError) {
      console.error(promiseError);
    }
    return {
      priceByProductApiName,
      buyingMotionPropsByProductApiName
    };
  });
};